const bulkChangeOrderStatus = {
  concept: 'CONCEPT',
  readyForProcessing: 'READY_FOR_PROCESSING',
  processing: 'PROCESSING',
  paused: 'PAUSED',
  checked: 'CHECKED',
  processed: 'PROCESSED',
  error: 'ERROR',
}
export default bulkChangeOrderStatus
